// Towers.tsx
import GazableButton from "components/GazableButton/GazableButton";
import { LEVEL_ONE_PLACEMENT_TILES } from "constants/constants";
import gazableButtons from "constants/gazableButtons";
import {
  getScaleToResolution,
  scalePositionToResolution,
} from "helpers/mathFunctions";
import { getTowerCost } from "helpers/towerHelpers";
import { useEffect, useState } from "react";
import { useCanvasStore } from "store/CanvasStore";

const Towers = () => {
  const {
    canvasObj,
    isBuilding,
    towerType,
    stopTowerBuild,
    showHideTowerBuild,
  } = useCanvasStore();
  const [placementTiles, setPlacementTiles] = useState<
    { x: number; y: number }[]
  >([]);

  useEffect(() => {
    // Initialize placement tiles based on LEVEL_ONE_PLACEMENT_TILES
    if (canvasObj?.width) {
      if (
        (placementTiles.length === 0 &&
          canvasObj.placementTiles.length !== 0) ||
        canvasObj.activePlacementTile.isOccupied === false
      ) {
        const tiles: { x: number; y: number }[] = [];
        LEVEL_ONE_PLACEMENT_TILES.forEach((row, rowIndex) => {
          row.forEach((column, columnIndex) => {
            if (column !== 0) {
              tiles.push(
                scalePositionToResolution(
                  { x: columnIndex * 32, y: rowIndex * 32 },
                  canvasObj.width
                )
              );
            }
          });
        });
        setPlacementTiles(tiles);
      }
    }
  }, [canvasObj, placementTiles.length, canvasObj?.activePlacementTile]);

  const handleTowerClick = (tile: { x: number; y: number }) => {
    if (canvasObj && canvasObj.gameStats.moneyLeft >= getTowerCost(towerType)) {
      canvasObj.handlePlacementTowerClick(
        tile.x,
        tile.y,
        getScaleToResolution(canvasObj.width),
        towerType
      );
      setPlacementTiles((previousTiles) =>
        previousTiles.filter(
          (previousTile) =>
            previousTile.x !== tile.x || previousTile.y !== tile.y
        )
      );
      stopTowerBuild();
      showHideTowerBuild();
    }
  };

  return (
    <div id="gazableDiv">
      {isBuilding &&
        canvasObj?.paused &&
        placementTiles.map((tile, index) => (
          <GazableButton
            key={index}
            type={gazableButtons.squareButtonTwo}
            content={""}
            onClick={() => handleTowerClick(tile)}
            style={{
              position: "absolute",
              top: `${tile.y - 5}px `,
              left: `${tile.x}px`,
              height: 64 * getScaleToResolution(canvasObj?.width),
              width: 64 * getScaleToResolution(canvasObj?.width),
            }}
          />
        ))}
    </div>
  );
};

export default Towers;
